import { addHours, addMinutes, format } from "date-fns";

import { NotesType as Note, NotesType } from "./interface";

export const getValuesForNote = (
  note: Note<boolean>,
  isLenderPlatform: boolean
) => {
  const typedNote = note as NotesType<boolean>,
    rawDate = isLenderPlatform
      ? (typedNote as NotesType<true>).CreatedAt
      : (typedNote as NotesType<false>).createdAt,
    validDate = new Date(rawDate),
    createdBy = isLenderPlatform
      ? (typedNote as NotesType<true>).CreatedBy
      : (typedNote as NotesType<false>).createdBy,
    userGroup = isLenderPlatform
      ? (typedNote as NotesType<true>).UserGroup
      : (typedNote as NotesType<false>).userGroup,
    noteText = isLenderPlatform
      ? (typedNote as NotesType<true>).Note
      : (typedNote as NotesType<false>).note;

  let createdAt = addHours(validDate, 5);
  createdAt = addMinutes(createdAt, 30);

  return {
    createdBy,
    userGroup,
    noteText,
    createdAt,
  };
};
